import React from 'react';
import {
    PULSE_ISSUER,
    certificateSerial,
    coverClassLabel,
    formatIssuedStamp,
    formatLongDate,
    useClassLabel,
    vehicleTitle
} from '../pulsePrint';

function MotorTpiCertificate({ policy, customer, managerName, examinedBy, issuedAt, signature }) {
    const sig = signature || policy.digitalSignature || null;
    const signer = (sig && sig.signerName) || managerName;
    const plate = (policy.vehicle && policy.vehicle.registrationNumber) || '—';
    const holder = (customer && customer.fullName) || (policy.policyHolder && policy.policyHolder.fullName) || '—';
    const tin = (customer && customer.tin) || '0';
    const excess = Number(policy.compulsoryExcessGMD || 1000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const stampDate = formatLongDate(issuedAt || policy.approvedDate || policy.effectiveDate);

    return (
        <article className="tpi-sheet">
            <div className="tpi-wm" aria-hidden="true">PULSE INSURANCE</div>
            <header className="tpi-head">
                <div className="tpi-brand">
                    <div className="tpi-mark" aria-hidden="true">
                        <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#fff" strokeWidth="2.4">
                            <polyline points="4,14 8,14 10,10 12,16 14,6 16,14 20,14" />
                        </svg>
                    </div>
                    <div>
                        <div className="tpi-co">{PULSE_ISSUER.name}</div>
                        <div className="tpi-addr">
                            {PULSE_ISSUER.address}<br />
                            {PULSE_ISSUER.locality}<br />
                            {PULSE_ISSUER.country}<br />
                            Tel: {PULSE_ISSUER.tel}
                        </div>
                    </div>
                </div>
                <div className="tpi-serial">{certificateSerial(policy)}</div>
            </header>

            <h1 className="tpi-act">MOTOR VEHICLES (THIRD PARTY INSURANCE) ACT, 1948</h1>
            <h2 className="tpi-title">CERTIFICATE OF INSURANCE</h2>

            <div className="tpi-meta">
                <span>{coverClassLabel(policy)}</span>
                <span>{useClassLabel(policy)}</span>
                <span>TIN {tin}</span>
            </div>

            <div className="tpi-policy">Policy No: <strong>{policy.policyNumber || '—'}</strong></div>

            <ol className="tpi-fields">
                <li>
                    <span>Vehicle Registration Number:</span>
                    <strong>{plate}</strong>
                    <em>{vehicleTitle(policy)}</em>
                </li>
                <li>
                    <span>Policy Holder:</span>
                    <strong>{String(holder).toUpperCase()}</strong>
                </li>
                <li>
                    <span>Effective Date of cover:</span>
                    <strong>{formatLongDate(policy.effectiveDate)}</strong>
                </li>
                <li>
                    <span>Date of Expiry of Insurance:</span>
                    <strong>{formatLongDate(policy.expiryDate)}</strong>
                </li>
                <li>
                    <span>Persons or classes of persons entitled to drive*</span>
                    <p><strong>a.</strong> The Policy Holder. The Policy holder may also drive a motor car not belonging to him and not hired to him under a hire-purchase agreement.</p>
                    <p><strong>b.</strong> Any person who is driving on the policy holder&apos;s order or with his permission. Provided that the person driving is permitted in accordance with the licensing or other laws or regulations to drive the Motor Vehicle and is not disqualified by order of a Court of Law or by reason of any enactment or regulation in that behalf from driving such Motor Vehicle.</p>
                </li>
                <li>
                    <span>Limitation(s) as to use*</span>
                    <p>Use for social, domestic and pleasure purposes and for the policy holder&apos;s business.</p>
                    <p>The policy does not cover use for hire or reward, racing, pace-making, reliability trial, speed-testing nor use in connection with the Motor Trade.</p>
                </li>
            </ol>
            <p className="tpi-note">* Limitations rendered inoperative by the Motor Vehicle (Third Party Insurance) Act 1948 (The Gambia) are not included in this Certificate of Insurance.</p>

            <div className="tpi-row">
                <div><strong>COMPULSORY EXCESS:</strong> {excess} DALASIS</div>
                <div><strong>ISSUED:</strong> {formatIssuedStamp(issuedAt)}</div>
            </div>

            <p className="tpi-certify">
                I/WE HEREBY CERTIFY that the Policy to which this Certificate relates is issued in accordance with the provisions of the Motor Vehicle (Third Party Insurance) ACT 1948 (The Gambia).
            </p>
            <p className="tpi-behalf">For and on behalf of <strong>{PULSE_ISSUER.legalName}</strong></p>

            <div className="tpi-signs">
                <div>
                    <div className="tpi-sign-line">{examinedBy || signer || '\u00a0'}</div>
                    <div>Examined by</div>
                </div>
                <div className="tpi-stamp">
                    <div className="tpi-stamp-ring">
                        <div className="tpi-stamp-top">{PULSE_ISSUER.name}</div>
                        <div className="tpi-stamp-mid">MOTOR DEPARTMENT</div>
                        <div className="tpi-stamp-bot">DATE: {stampDate}</div>
                        <div className="tpi-stamp-sign">{signer || 'Authorised'}</div>
                    </div>
                </div>
                <div>
                    <div className="tpi-sign-line">{signer || '\u00a0'}</div>
                    <div>Manager</div>
                </div>
            </div>
            <div className="tpi-holo" aria-hidden="true">PULSE</div>
            {sig && sig.signerName ? (
                <div className="tpi-crypto">
                    <div><strong>Digitally signed by</strong> {sig.signerName} · {sig.signerEmail}</div>
                    <div>Alg {sig.alg || 'ECDSA-P256-SHA256'} · {sig.signedAt || ''}</div>
                    <div>ID {sig.signatureId}</div>
                    {sig.payloadHash ? <div>SHA-256 {sig.payloadHash}</div> : null}
                    {sig.fingerprint ? <div>Key {sig.fingerprint}</div> : null}
                </div>
            ) : null}
        </article>
    );
}

export default MotorTpiCertificate;
